module.exports = __webpack_public_path__ + "img/icono-unigas.e567ddc4.png";